export const stageLabels = {
  group: "Fase de grupos",
  round32: "Dieciseisavos",
  round16: "Octavos",
  quarter: "Cuartos",
  semi: "Semifinales",
  third: "Tercer lugar",
  final: "Final"
};

export const stageMultipliers = {
  group: 1,
  round32: 1,
  round16: 1,
  quarter: 1,
  semi: 1,
  third: 1,
  final: 1
};

export const teams = [
  { code: "MEX", name: "México", flag: "🇲🇽", group: "A" },
  { code: "RSA", name: "Sudáfrica", flag: "🇿🇦", group: "A" },
  { code: "KOR", name: "Corea del Sur", flag: "🇰🇷", group: "A" },
  { code: "CZE", name: "República Checa", flag: "🇨🇿", group: "A" },
  { code: "CAN", name: "Canadá", flag: "🇨🇦", group: "B" },
  { code: "BIH", name: "Bosnia y Herzegovina", flag: "🇧🇦", group: "B" },
  { code: "QAT", name: "Catar", flag: "🇶🇦", group: "B" },
  { code: "SUI", name: "Suiza", flag: "🇨🇭", group: "B" },
  { code: "BRA", name: "Brasil", flag: "🇧🇷", group: "C" },
  { code: "MAR", name: "Marruecos", flag: "🇲🇦", group: "C" },
  { code: "HAI", name: "Haití", flag: "🇭🇹", group: "C" },
  { code: "SCO", name: "Escocia", flag: "🏴", group: "C" },
  { code: "USA", name: "Estados Unidos", flag: "🇺🇸", group: "D" },
  { code: "PAR", name: "Paraguay", flag: "🇵🇾", group: "D" },
  { code: "AUS", name: "Australia", flag: "🇦🇺", group: "D" },
  { code: "TUR", name: "Turquía", flag: "🇹🇷", group: "D" },
  { code: "GER", name: "Alemania", flag: "🇩🇪", group: "E" },
  { code: "CUW", name: "Curazao", flag: "🇨🇼", group: "E" },
  { code: "CIV", name: "Costa de Marfil", flag: "🇨🇮", group: "E" },
  { code: "ECU", name: "Ecuador", flag: "🇪🇨", group: "E" },
  { code: "NED", name: "Países Bajos", flag: "🇳🇱", group: "F" },
  { code: "JPN", name: "Japón", flag: "🇯🇵", group: "F" },
  { code: "SWE", name: "Suecia", flag: "🇸🇪", group: "F" },
  { code: "TUN", name: "Túnez", flag: "🇹🇳", group: "F" },
  { code: "BEL", name: "Bélgica", flag: "🇧🇪", group: "G" },
  { code: "EGY", name: "Egipto", flag: "🇪🇬", group: "G" },
  { code: "IRN", name: "Irán", flag: "🇮🇷", group: "G" },
  { code: "NZL", name: "Nueva Zelanda", flag: "🇳🇿", group: "G" },
  { code: "ESP", name: "España", flag: "🇪🇸", group: "H" },
  { code: "CPV", name: "Cabo Verde", flag: "🇨🇻", group: "H" },
  { code: "KSA", name: "Arabia Saudita", flag: "🇸🇦", group: "H" },
  { code: "URU", name: "Uruguay", flag: "🇺🇾", group: "H" },
  { code: "FRA", name: "Francia", flag: "🇫🇷", group: "I" },
  { code: "SEN", name: "Senegal", flag: "🇸🇳", group: "I" },
  { code: "IRQ", name: "Irak", flag: "🇮🇶", group: "I" },
  { code: "NOR", name: "Noruega", flag: "🇳🇴", group: "I" },
  { code: "ARG", name: "Argentina", flag: "🇦🇷", group: "J" },
  { code: "ALG", name: "Argelia", flag: "🇩🇿", group: "J" },
  { code: "AUT", name: "Austria", flag: "🇦🇹", group: "J" },
  { code: "JOR", name: "Jordania", flag: "🇯🇴", group: "J" },
  { code: "POR", name: "Portugal", flag: "🇵🇹", group: "K" },
  { code: "COD", name: "RD Congo", flag: "🇨🇩", group: "K" },
  { code: "UZB", name: "Uzbekistán", flag: "🇺🇿", group: "K" },
  { code: "COL", name: "Colombia", flag: "🇨🇴", group: "K" },
  { code: "ENG", name: "Inglaterra", flag: "🏴", group: "L" },
  { code: "CRO", name: "Croacia", flag: "🇭🇷", group: "L" },
  { code: "GHA", name: "Ghana", flag: "🇬🇭", group: "L" },
  { code: "PAN", name: "Panamá", flag: "🇵🇦", group: "L" }
];

const officialKickoffsEt = {
  1: ["2026-06-11", "15:00"],
  2: ["2026-06-11", "22:00"],
  3: ["2026-06-12", "15:00"],
  4: ["2026-06-12", "21:00"],
  5: ["2026-06-13", "21:00"],
  6: ["2026-06-14", "00:00"],
  7: ["2026-06-13", "18:00"],
  8: ["2026-06-13", "15:00"],
  9: ["2026-06-14", "19:00"],
  10: ["2026-06-14", "13:00"],
  11: ["2026-06-14", "16:00"],
  12: ["2026-06-14", "22:00"],
  13: ["2026-06-15", "18:00"],
  14: ["2026-06-15", "12:00"],
  15: ["2026-06-15", "21:00"],
  16: ["2026-06-15", "15:00"],
  17: ["2026-06-16", "15:00"],
  18: ["2026-06-16", "18:00"],
  19: ["2026-06-16", "21:00"],
  20: ["2026-06-17", "00:00"],
  21: ["2026-06-17", "19:00"],
  22: ["2026-06-17", "16:00"],
  23: ["2026-06-17", "13:00"],
  24: ["2026-06-17", "22:00"],
  25: ["2026-06-18", "12:00"],
  26: ["2026-06-18", "15:00"],
  27: ["2026-06-18", "18:00"],
  28: ["2026-06-18", "21:00"],
  29: ["2026-06-19", "20:30"],
  30: ["2026-06-19", "18:00"],
  31: ["2026-06-19", "23:00"],
  32: ["2026-06-19", "15:00"],
  33: ["2026-06-20", "16:00"],
  34: ["2026-06-20", "20:00"],
  35: ["2026-06-20", "13:00"],
  36: ["2026-06-21", "00:00"],
  37: ["2026-06-21", "18:00"],
  38: ["2026-06-21", "12:00"],
  39: ["2026-06-21", "15:00"],
  40: ["2026-06-21", "21:00"],
  41: ["2026-06-22", "20:00"],
  42: ["2026-06-22", "17:00"],
  43: ["2026-06-22", "13:00"],
  44: ["2026-06-22", "23:00"],
  45: ["2026-06-23", "16:00"],
  46: ["2026-06-23", "19:00"],
  47: ["2026-06-23", "13:00"],
  48: ["2026-06-23", "22:00"],
  49: ["2026-06-24", "18:00"],
  50: ["2026-06-24", "18:00"],
  51: ["2026-06-24", "15:00"],
  52: ["2026-06-24", "15:00"],
  53: ["2026-06-24", "21:00"],
  54: ["2026-06-24", "21:00"],
  55: ["2026-06-25", "16:00"],
  56: ["2026-06-25", "16:00"],
  57: ["2026-06-25", "19:00"],
  58: ["2026-06-25", "19:00"],
  59: ["2026-06-25", "22:00"],
  60: ["2026-06-25", "22:00"],
  61: ["2026-06-26", "15:00"],
  62: ["2026-06-26", "15:00"],
  63: ["2026-06-26", "23:00"],
  64: ["2026-06-26", "23:00"],
  65: ["2026-06-26", "20:00"],
  66: ["2026-06-26", "20:00"],
  67: ["2026-06-27", "17:00"],
  68: ["2026-06-27", "17:00"],
  69: ["2026-06-27", "22:00"],
  70: ["2026-06-27", "22:00"],
  71: ["2026-06-27", "19:30"],
  72: ["2026-06-27", "19:30"],
  73: ["2026-06-28", "15:00"],
  74: ["2026-06-29", "16:30"],
  75: ["2026-06-29", "21:00"],
  76: ["2026-06-29", "13:00"],
  77: ["2026-06-30", "17:00"],
  78: ["2026-06-30", "13:00"],
  79: ["2026-06-30", "21:00"],
  80: ["2026-07-01", "12:00"],
  81: ["2026-07-01", "20:00"],
  82: ["2026-07-01", "16:00"],
  83: ["2026-07-02", "19:00"],
  84: ["2026-07-02", "15:00"],
  85: ["2026-07-02", "23:00"],
  86: ["2026-07-03", "18:00"],
  87: ["2026-07-03", "21:30"],
  88: ["2026-07-03", "14:00"],
  89: ["2026-07-04", "17:00"],
  90: ["2026-07-04", "13:00"],
  91: ["2026-07-05", "16:00"],
  92: ["2026-07-05", "20:00"],
  93: ["2026-07-06", "15:00"],
  94: ["2026-07-06", "20:00"],
  95: ["2026-07-07", "12:00"],
  96: ["2026-07-07", "16:00"],
  97: ["2026-07-09", "16:00"],
  98: ["2026-07-10", "15:00"],
  99: ["2026-07-11", "17:00"],
  100: ["2026-07-11", "21:00"],
  101: ["2026-07-14", "15:00"],
  102: ["2026-07-15", "15:00"],
  103: ["2026-07-18", "17:00"],
  104: ["2026-07-19", "15:00"]
};

const venueByMatch = {
  1: ["2026-06-11", "Mexico City Stadium", 1],
  2: ["2026-06-11", "Estadio Guadalajara", 3],
  3: ["2026-06-12", "Toronto Stadium", 1],
  4: ["2026-06-12", "Los Angeles Stadium", 3],
  5: ["2026-06-13", "Boston Stadium", 1],
  6: ["2026-06-13", "BC Place Vancouver", 2],
  7: ["2026-06-13", "New York New Jersey Stadium", 3],
  8: ["2026-06-13", "San Francisco Bay Area Stadium", 4],
  9: ["2026-06-14", "Philadelphia Stadium", 1],
  10: ["2026-06-14", "Houston Stadium", 2],
  11: ["2026-06-14", "Dallas Stadium", 3],
  12: ["2026-06-14", "Estadio Monterrey", 4],
  13: ["2026-06-15", "Miami Stadium", 1],
  14: ["2026-06-15", "Atlanta Stadium", 2],
  15: ["2026-06-15", "Los Angeles Stadium", 3],
  16: ["2026-06-15", "Seattle Stadium", 4],
  17: ["2026-06-16", "New York New Jersey Stadium", 1],
  18: ["2026-06-16", "Boston Stadium", 2],
  19: ["2026-06-16", "Kansas City Stadium", 3],
  20: ["2026-06-16", "San Francisco Bay Area Stadium", 4],
  21: ["2026-06-17", "Toronto Stadium", 1],
  22: ["2026-06-17", "Dallas Stadium", 2],
  23: ["2026-06-17", "Houston Stadium", 3],
  24: ["2026-06-17", "Mexico City Stadium", 4],
  25: ["2026-06-18", "Atlanta Stadium", 1],
  26: ["2026-06-18", "Los Angeles Stadium", 2],
  27: ["2026-06-18", "BC Place Vancouver", 3],
  28: ["2026-06-18", "Estadio Guadalajara", 4],
  29: ["2026-06-19", "Philadelphia Stadium", 1],
  30: ["2026-06-19", "Boston Stadium", 2],
  31: ["2026-06-19", "San Francisco Bay Area Stadium", 3],
  32: ["2026-06-19", "Seattle Stadium", 4],
  33: ["2026-06-20", "Toronto Stadium", 1],
  34: ["2026-06-20", "Kansas City Stadium", 2],
  35: ["2026-06-20", "Houston Stadium", 3],
  36: ["2026-06-20", "Estadio Monterrey", 4],
  37: ["2026-06-21", "Miami Stadium", 1],
  38: ["2026-06-21", "Atlanta Stadium", 2],
  39: ["2026-06-21", "Los Angeles Stadium", 3],
  40: ["2026-06-21", "BC Place Vancouver", 4],
  41: ["2026-06-22", "New York New Jersey Stadium", 1],
  42: ["2026-06-22", "Philadelphia Stadium", 2],
  43: ["2026-06-22", "Dallas Stadium", 3],
  44: ["2026-06-22", "San Francisco Bay Area Stadium", 4],
  45: ["2026-06-23", "Boston Stadium", 1],
  46: ["2026-06-23", "Toronto Stadium", 2],
  47: ["2026-06-23", "Houston Stadium", 3],
  48: ["2026-06-23", "Estadio Guadalajara", 4],
  49: ["2026-06-24", "Miami Stadium", 1],
  50: ["2026-06-24", "Atlanta Stadium", 1],
  51: ["2026-06-24", "BC Place Vancouver", 2],
  52: ["2026-06-24", "Seattle Stadium", 2],
  53: ["2026-06-24", "Mexico City Stadium", 3],
  54: ["2026-06-24", "Estadio Monterrey", 3],
  55: ["2026-06-25", "Philadelphia Stadium", 1],
  56: ["2026-06-25", "New York New Jersey Stadium", 1],
  57: ["2026-06-25", "Dallas Stadium", 2],
  58: ["2026-06-25", "Kansas City Stadium", 2],
  59: ["2026-06-25", "Los Angeles Stadium", 3],
  60: ["2026-06-25", "San Francisco Bay Area Stadium", 3],
  61: ["2026-06-26", "Boston Stadium", 1],
  62: ["2026-06-26", "Toronto Stadium", 1],
  63: ["2026-06-26", "Seattle Stadium", 2],
  64: ["2026-06-26", "BC Place Vancouver", 2],
  65: ["2026-06-26", "Houston Stadium", 3],
  66: ["2026-06-26", "Estadio Guadalajara", 3],
  67: ["2026-06-27", "New York New Jersey Stadium", 1],
  68: ["2026-06-27", "Philadelphia Stadium", 1],
  69: ["2026-06-27", "Kansas City Stadium", 2],
  70: ["2026-06-27", "Dallas Stadium", 2],
  71: ["2026-06-27", "Miami Stadium", 3],
  72: ["2026-06-27", "Atlanta Stadium", 3]
};

const groupPairings = [
  [1, "A", "MEX", "RSA"],
  [2, "A", "KOR", "CZE"],
  [3, "B", "CAN", "BIH"],
  [4, "D", "USA", "PAR"],
  [5, "C", "HAI", "SCO"],
  [6, "D", "AUS", "TUR"],
  [7, "C", "BRA", "MAR"],
  [8, "B", "QAT", "SUI"],
  [9, "E", "CIV", "ECU"],
  [10, "E", "GER", "CUW"],
  [11, "F", "NED", "JPN"],
  [12, "F", "SWE", "TUN"],
  [13, "H", "KSA", "URU"],
  [14, "H", "ESP", "CPV"],
  [15, "G", "IRN", "NZL"],
  [16, "G", "BEL", "EGY"],
  [17, "I", "FRA", "SEN"],
  [18, "I", "IRQ", "NOR"],
  [19, "J", "ARG", "ALG"],
  [20, "J", "AUT", "JOR"],
  [21, "L", "GHA", "PAN"],
  [22, "L", "ENG", "CRO"],
  [23, "K", "POR", "COD"],
  [24, "K", "UZB", "COL"],
  [25, "A", "CZE", "RSA"],
  [26, "B", "SUI", "BIH"],
  [27, "B", "CAN", "QAT"],
  [28, "A", "MEX", "KOR"],
  [29, "C", "BRA", "HAI"],
  [30, "C", "SCO", "MAR"],
  [31, "D", "TUR", "PAR"],
  [32, "D", "USA", "AUS"],
  [33, "E", "GER", "CIV"],
  [34, "E", "ECU", "CUW"],
  [35, "F", "NED", "SWE"],
  [36, "F", "TUN", "JPN"],
  [37, "H", "URU", "CPV"],
  [38, "H", "ESP", "KSA"],
  [39, "G", "BEL", "IRN"],
  [40, "G", "NZL", "EGY"],
  [41, "I", "NOR", "SEN"],
  [42, "I", "FRA", "IRQ"],
  [43, "J", "ARG", "AUT"],
  [44, "J", "JOR", "ALG"],
  [45, "L", "ENG", "GHA"],
  [46, "L", "PAN", "CRO"],
  [47, "K", "POR", "UZB"],
  [48, "K", "COL", "COD"],
  [49, "C", "SCO", "BRA"],
  [50, "C", "MAR", "HAI"],
  [51, "B", "SUI", "CAN"],
  [52, "B", "BIH", "QAT"],
  [53, "A", "CZE", "MEX"],
  [54, "A", "RSA", "KOR"],
  [55, "E", "CUW", "CIV"],
  [56, "E", "ECU", "GER"],
  [57, "F", "JPN", "SWE"],
  [58, "F", "TUN", "NED"],
  [59, "D", "TUR", "USA"],
  [60, "D", "PAR", "AUS"],
  [61, "I", "NOR", "FRA"],
  [62, "I", "SEN", "IRQ"],
  [63, "G", "EGY", "IRN"],
  [64, "G", "NZL", "BEL"],
  [65, "H", "CPV", "KSA"],
  [66, "H", "URU", "ESP"],
  [67, "L", "PAN", "ENG"],
  [68, "L", "CRO", "GHA"],
  [69, "J", "ALG", "AUT"],
  [70, "J", "JOR", "ARG"],
  [71, "K", "COL", "POR"],
  [72, "K", "COD", "UZB"]
];

const knockoutDefinitions = [
  [73, "round32", "2026-06-28", "Los Angeles Stadium", "2A", "2B"],
  [74, "round32", "2026-06-29", "Boston Stadium", "1E", "3A/B/C/D/F"],
  [75, "round32", "2026-06-29", "Estadio Monterrey", "1F", "2C"],
  [76, "round32", "2026-06-29", "Houston Stadium", "1C", "2F"],
  [77, "round32", "2026-06-30", "New York New Jersey Stadium", "1I", "3C/D/F/G/H"],
  [78, "round32", "2026-06-30", "Dallas Stadium", "2E", "2I"],
  [79, "round32", "2026-06-30", "Mexico City Stadium", "1A", "3C/E/F/H/I"],
  [80, "round32", "2026-07-01", "Atlanta Stadium", "1L", "3E/H/I/J/K"],
  [81, "round32", "2026-07-01", "San Francisco Bay Area Stadium", "1D", "3B/E/F/I/J"],
  [82, "round32", "2026-07-01", "Seattle Stadium", "1G", "3A/E/H/I/J"],
  [83, "round32", "2026-07-02", "Toronto Stadium", "2K", "2L"],
  [84, "round32", "2026-07-02", "Los Angeles Stadium", "1H", "2J"],
  [85, "round32", "2026-07-02", "BC Place Vancouver", "1B", "3E/F/G/I/J"],
  [86, "round32", "2026-07-03", "Miami Stadium", "1J", "2H"],
  [87, "round32", "2026-07-03", "Kansas City Stadium", "1K", "3D/E/I/J/L"],
  [88, "round32", "2026-07-03", "Dallas Stadium", "2D", "2G"],
  [89, "round16", "2026-07-04", "Philadelphia Stadium", "W74", "W77"],
  [90, "round16", "2026-07-04", "Houston Stadium", "W73", "W75"],
  [91, "round16", "2026-07-05", "New York New Jersey Stadium", "W76", "W78"],
  [92, "round16", "2026-07-05", "Mexico City Stadium", "W79", "W80"],
  [93, "round16", "2026-07-06", "Dallas Stadium", "W83", "W84"],
  [94, "round16", "2026-07-06", "Seattle Stadium", "W81", "W82"],
  [95, "round16", "2026-07-07", "Atlanta Stadium", "W86", "W88"],
  [96, "round16", "2026-07-07", "BC Place Vancouver", "W85", "W87"],
  [97, "quarter", "2026-07-09", "Boston Stadium", "W89", "W90"],
  [98, "quarter", "2026-07-10", "Los Angeles Stadium", "W93", "W94"],
  [99, "quarter", "2026-07-11", "Miami Stadium", "W91", "W92"],
  [100, "quarter", "2026-07-11", "Kansas City Stadium", "W95", "W96"],
  [101, "semi", "2026-07-14", "Dallas Stadium", "W97", "W98"],
  [102, "semi", "2026-07-15", "Atlanta Stadium", "W99", "W100"],
  [103, "third", "2026-07-18", "Miami Stadium", "L101", "L102"],
  [104, "final", "2026-07-19", "New York New Jersey Stadium", "W101", "W102"]
];

function buildDate(matchNumber) {
  const [date, time] = officialKickoffsEt[matchNumber];
  return new Date(`${date}T${time}:00-04:00`).toISOString();
}

function buildLockAt(dateTime) {
  return new Date(new Date(dateTime).getTime() - 30 * 60 * 1000).toISOString();
}

function makeGroupMatch([matchNumber, group, homeTeam, awayTeam]) {
  const [, venue] = venueByMatch[matchNumber];
  const dateTime = buildDate(matchNumber);

  return {
    id: `match-${String(matchNumber).padStart(3, "0")}`,
    matchNumber,
    homeTeam,
    awayTeam,
    dateTime,
    venue,
    stage: "group",
    group,
    multiplier: stageMultipliers.group,
    status: "open",
    result: null,
    lockAt: buildLockAt(dateTime)
  };
}

function makeKnockoutMatch([matchNumber, stage, , venue, homeLabel, awayLabel]) {
  const dateTime = buildDate(matchNumber);

  return {
    id: `match-${String(matchNumber).padStart(3, "0")}`,
    matchNumber,
    homeTeam: "TBD",
    awayTeam: "TBD",
    homePlaceholder: homeLabel,
    awayPlaceholder: awayLabel,
    dateTime,
    venue,
    stage,
    group: null,
    multiplier: stageMultipliers[stage],
    status: "upcoming",
    result: null,
    lockAt: buildLockAt(dateTime)
  };
}

export const matches = [
  ...groupPairings.map(makeGroupMatch),
  ...knockoutDefinitions.map(makeKnockoutMatch)
].sort((a, b) => a.matchNumber - b.matchNumber);

export const sourceNotes = [
  "FIFA World Cup 26 match schedule PDF dated 10 April 2026: official kick-off times are listed in Eastern Time.",
  "Kick-off times are stored as absolute timestamps converted from ET so Guatemala users see local time correctly."
];
